import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveServico } from "@services/Servico/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index";
import { flagAuditoriaOptions } from "@enums/FlagAuditoria/Index";
import ValidationsServico from "@validations/Servico/Validations";

const Create = ({ onSave }) => {
    const currentYear = new Date().getFullYear();

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
    } = useForm({
        defaultValues: {
            ano: currentYear,
            flagAuditoria: null
        },
    });

    const onSubmit = async (data) => {
        try {
            const { warningMessage } = ValidationsServico();

            const confirmed = await warningMessage(data.flagAuditoria?.value);
            if (!confirmed) return; // Usuário cancelou, não prossegue

            SweetAlert.loading();

            const payload = {
                ano: data.ano,
                descricao: data.descricao,
                servico: data.servico,
                flagAuditoria: data.flagAuditoria?.value,
                flgStatus: true
            };

            const result = await SaveServico(payload);

            SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');

            onSave({ ...result });

            reset();

        } catch (error) {
            const errorMessage = error.parsed?.message || 'Não foi possível salvar o serviço.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="form">
            <div className="row py-3">

                <div className="col-5 col-md-5">
                    <InputTextComp
                        label={"Ano"}
                        name={"ano"}
                        {...register('ano')}
                        placeholder={"Preencher com um ano"}
                        hoverMessage={"Preencher um ano com caracteres exclusivamente numéricos. Previamente preenchido com o ano vigente."}
                        maxLength={4}
                        minLength={4}
                        pattern="\d{4}"
                        required={true}
                    />

                    <SelectOptionComp
                        label={"É uma auditoria?"}
                        options={flagAuditoriaOptions}
                        value={watch('flagAuditoria')}
                        onChange={(selected) => setValue("flagAuditoria", selected)}
                        placeholder={"Selecionar uma opção"}
                        hoverMessage={"Selecionar um opção"}
                        required
                    />
                </div>

                <div className="col-8 col-md-8">
                    <InputTextComp
                        label={"Serviço"}
                        name={"servico"}
                        {...register('servico')}
                        placeholder={"Preencher com um serviço"}
                        hoverMessage={"Preencher com um serviço"}
                        maxLength={255}
                        required={true}
                    />

                    <InputTextComp
                        label={"Descrição"}
                        name={"descricao"}
                        {...register('descricao')}
                        placeholder={"Preencher com uma descrição"}
                        hoverMessage={"Preencher com uma descrição"}
                        maxLength={255}
                        required={true}
                    />
                </div>

                <div className="col-md-8 mt-4">
                    <ButtonComp
                        title={"SALVAR"}
                        type={"submit"}
                        buttonColor={"#2b97be"}
                        classnameIcon={"fa-regular fa-floppy-disk"}
                        hoverMessage={"Botão para confirmar o cadastro"}
                    />
                </div>

            </div>
        </form>
    );
}

export default Create;